const JA_READY_TIMEOUT = 3000;
const JA_READY_INTERVAL = 50;

type JaGlobalKey = 'expLogJSON' | 'log' | 'logJSON';
export type JaLogger = (...args: unknown[]) => unknown;

type JaWindow = Window & Partial<Record<JaGlobalKey, JaLogger>>;

const pendingLoggers = new Map<JaGlobalKey, Promise<JaLogger | null>>();

const getLogger = (key: JaGlobalKey): JaLogger | undefined => (window as JaWindow)[key];

// 同一 JA API 复用等待 Promise；三个全局对象语义不同，不能跨 API 共用一个 logger 结果。
const waitForGlobal = (key: JaGlobalKey): Promise<JaLogger | null> => {
  const current = getLogger(key);
  if (current) {
    return Promise.resolve(current);
  }

  const pending = pendingLoggers.get(key);
  if (pending) {
    return pending;
  }

  const request = new Promise<JaLogger | null>(resolve => {
    let settled = false;
    let interval = 0;
    let timeout = 0;
    const finish = (value: JaLogger | null) => {
      if (settled) {
        return;
      }
      settled = true;
      window.clearInterval(interval);
      window.clearTimeout(timeout);
      pendingLoggers.delete(key);
      resolve(value);
    };

    interval = window.setInterval(() => {
      const logger = getLogger(key);
      if (logger) {
        finish(logger);
      }
    }, JA_READY_INTERVAL);
    // 脚本被拦截时返回 null，让调用方显式跳过上报，而不是伪造成功的空函数。
    timeout = window.setTimeout(() => finish(null), JA_READY_TIMEOUT);
  });

  pendingLoggers.set(key, request);
  return request;
};

export default {
  getExpLogJSON: () => waitForGlobal('expLogJSON'),
  getLog: () => waitForGlobal('log'),
  getLogJSON: () => waitForGlobal('logJSON'),
};
